import { useState, useEffect } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';


import Navigation from './components/Navigation';
import { NavLinkHeaders } from './components/Navigation';

import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';

import Admin from './admin/Admin';

import Home from './Home';
import Login from './Login';
import ContactForm from './ContactUs';
import ContactInfo from './ContactInfo';
import ClientCenter from './ClientCenter';
import Newsletters from './Newsletters';
import UsefulReading from './UsefulReading';
import RelatedArticles from './RelatedArticles';
import Links from './Links';
import SalesFAQ from './SalesFAQ';
import TerraStationOverview from './TerraStationOverview';
import Fliers from './Fliers';
import TechSheets from './TechSheets';
import Privacy from './Privacy';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import NotFound from './NotFound';

// related articles
import RelatedArticlesSampleImageLogHeaders from './RelatedArticlesSampleImageLogHeaders';
import RelatedArticlesEllipsoidConversions from './RelatedArticlesEllipsoidConversions';
import RelatedArticlesKrigingAndTerraStation from './RelatedArticlesKrigingAndTerraStation';

import Profile from './Profile';
import Downloads from './Downloads';
import { AdminAuthProvider } from './auth/AdminAuthContext';
import ResetPassword from './ResetPassword';
import ForgotEmail from './ForgotEmail';

function App() {
  const [navActive, setNavActive] = useState(NavLinkHeaders.NONE);
  let navProps = {
    activeHeader: navActive
  };

  useEffect(() => {
    setNavActive(NavLinkHeaders.NONE);
  }, []);

  return (
  <AuthProvider>
    <Routes>
      <Route
        path="/admin"
        element={
          <AdminAuthProvider>
            <Admin />
          </AdminAuthProvider>
        }
      />

      <Route
        element={
          <div
            id="ts-page-wrapper"
            className="w-full h-screen flex justify-center items-center text-light-text"
          >
            <div
              id="ts-page-background"
              className="w-full h-full flex flex-col justify-start items-center bg-light-bg"
            >
              <div id="ts-page-align" className="w-full h-full">
                <Navigation key={0} {...navProps} />
                <Outlet />
              </div>
            </div>
          </div>
        }
      >
        <Route path="/" element={<Home />} />

        <Route
          element={
            <div className="ts-page-wallpaper flex bg-light-bg bg-[url(/contours2.png)] bg-fixed bg-center bg-repeat-y">
              <div className="ts-page-content w-full m-auto flex flex-col items-center xl:max-w-10/12 min-h-screen bg-light-bg p-4 pt-20">
                <Outlet />
              </div>
            </div>
          }
        >
          <Route path="/login" element={<Login />} />
          <Route path="/login/reset-password" element={<ResetPassword />} />
          <Route path="/login/reset-email" element={<ForgotEmail />} />
          <Route path="/contact-info" element={<ContactInfo />} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route path="/client-center" element={<ClientCenter />} />
          <Route path="/client-center/newsletters" element={<Newsletters />} />
          <Route path="/client-center/useful-reading" element={<UsefulReading />} />
          <Route path="/client-center/related-articles" element={<RelatedArticles />} />
          <Route path="/client-center/related-articles/sample-imagelog-headers" element={<RelatedArticlesSampleImageLogHeaders />} />
          <Route path="/client-center/related-articles/ellipsoid-conversions" element={<RelatedArticlesEllipsoidConversions />} />
          <Route path="/client-center/related-articles/kriging-and-terrastation" element={<RelatedArticlesKrigingAndTerraStation />} />
          <Route path="/client-center/links" element={<Links />} />
          <Route path="/sales-faq" element={<SalesFAQ />} />
          <Route path="/terrastation" element={<TerraStationOverview />} />
          <Route path="/terrastation/terrastation-fliers" element={<Fliers />} />
          <Route path="/terrastation/tech-sheets" element={<TechSheets />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy/terms-of-use" element={<TermsOfUse />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/account/profile" element={<Profile />} />
            <Route path="/account/downloads" element={<Downloads />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  </AuthProvider>
);
}

export default App;
